var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.isAuthenticated)?_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v(" Log Out ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }